import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { useFormikContext } from 'formik-2';
import { partnerShape } from '../types';
import css from './PartnerConfigurationShelf.css';
import attributionReturnRateCss from './AttributionReturnRate.css';
import { DropdownField } from '../../../components/widgets';

const ATTRIBUTION_RETURN_RATES = [100, 90, 80, 70, 60, 50, 40, 30, 20, 10];

export default function AttributionReturnRate({ partner, isReadonly = false }) {
    const { values, setFieldValue } = useFormikContext();
    const selectedReturnRate = values.attributionReturnRate || 100;

    const returnRateOptions = useMemo(
        () =>
            ATTRIBUTION_RETURN_RATES.map(rate => ({
                name: rate,
                display_name: rate === 100 ? '100% (default)' : `${rate}%`,
            })),
        []
    );

    const onReturnRateChanged = selectedOption => {
        setFieldValue('attributionReturnRate', selectedOption);
    };

    return (
        <div className={css.section}>
            <div className={css.title}>
                <Translate id="STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ADVANCED_SETTINGS.ATTRIBUTION_RETURN_RATE" />
            </div>
            <div className={attributionReturnRateCss.description}>
                <Translate
                    id="STATIC.PAGES.PARTNER_CONFIGURATION.SHELF.ADVANCED_SETTINGS.ATTRIBUTION_RETURN_RATE_DESCRIPTION"
                    data={{ partnerName: partner.displayName }}
                />
            </div>
            <DropdownField
                items={returnRateOptions}
                selected={selectedReturnRate}
                onChange={onReturnRateChanged}
                containerClass={attributionReturnRateCss.inputContainer}
                disabled={isReadonly}
                placement="bottom"
                disableFlip
            />
        </div>
    );
}

AttributionReturnRate.propTypes = {
    partner: partnerShape.isRequired,
    isReadonly: PropTypes.bool,
};
